@if (enabled) {
  <button
    class="transparent-btn"
    (click)="actionModal.openModal()"
    ngbTooltip="Marquer comme envoyée"
    i18n-ngbTooltip
  >
    <app-arrow-right-icon height="16px" width="16px" color="var(--brand-500)" />
  </button>
  <app-action-modal
    #actionModal
    [disabled]="submitted"
    [showHeader]="true"
    submitButtonClass="lty-btn-primary"
    size="md"
    headerIconState="success"
    (submitted)="sendCentralisation()"
  >
    <div class="proposals-send-icon" headerIcon>
      <app-check-circle-outline-icon
        height="16px"
        width="16px"
        color="var(--success-500)"
      />
    </div>
    <ng-container mainTitle i18n
      >Marquer la centralisation comme envoyée à l'assureur ?</ng-container
    >
    <ng-container submitButtonLabel i18n>Confirmer</ng-container>
  </app-action-modal>
}
